import { render, staticRenderFns } from "./PropertyLandFieldset.vue?vue&type=template&id=4b089f4e&scoped=true"
import script from "./PropertyLandFieldset.vue?vue&type=script&lang=js"
export * from "./PropertyLandFieldset.vue?vue&type=script&lang=js"
import style0 from "./PropertyLandFieldset.vue?vue&type=style&index=0&id=4b089f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b089f4e",
  null
  
)

export default component.exports